<div class="setting-section">
  <h2>Customer Management</h2>

  <app-customer-mngt-detail
    [countries]="countries"
    (customerSaved)="onCustomerSaved($event)"
  ></app-customer-mngt-detail>

  <mat-form-field>
    <input
      matInput
      type="text"
      (keyup)="doFilter($any($event.target).value)"
      placeholder="Filter Customers"
    />
  </mat-form-field>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" class="customersTable" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
        <td mat-cell *matCellDef="let element">{{ element.address }}</td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
        <td mat-cell *matCellDef="let element">{{ element.city }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
        <td mat-cell *matCellDef="let element">
          {{ getCountryById(element.country)?.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="timeZone">
        <th mat-header-cell *matHeaderCellDef>Time Zone</th>
        <td mat-cell *matCellDef="let element">{{ element.timeZone }}</td>
      </ng-container>
      <ng-container matColumnDef="hasImage">
        <th mat-header-cell *matHeaderCellDef>Image</th>
        <td mat-cell *matCellDef="let element">
          <a
            *ngIf="element.hasImage"
            mat-mini-fab
            (click)="viewImgDialog(element.id)"
            >View</a
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="actionButtonCol">
          <button mat-raised-button color="primary" (click)="edit(element)">
            Edit
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="deleteConfirmDialog(element)"
          >
            Delete
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">No customers found"</td>
      </tr>
    </table>
  </div>
</div>
